import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import userReducer from './reducers'; // Import your combined reducers
import adminReducer from './reducerAdmin'; // Import your combined reducers
import rootSaga from './rootSaga'; // Import your root saga
import notificationsReducer from "./notifications/notificationSlice";
import sessionReducer from "./session/sessionSlice";
import { SEND_LOGOUT_SUCCESS } from "./constant";

const sagaMiddleware = createSagaMiddleware();
const combinedReducer = combineReducers({ user: userReducer, admin: adminReducer, notifications: notificationsReducer, session: sessionReducer });
const rootReducer = (state, action) => combinedReducer(
  action.type === SEND_LOGOUT_SUCCESS ? undefined : state,
  action
);

const store = configureStore({
  reducer: rootReducer,
  //   middleware: [sagaMiddleware],
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
